export default __webpack_public_path__ + "static/media/banner-decor.132df102.svg";